import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useUserPlan } from 'hooks/useUserPlan'
import supabase from 'lib/supabase-browser'
import { initialChatbot } from 'store/useChatbotSettingsStore'
import { useAuth } from 'util/auth'

export const useCreateChatbotMutation = () => {
  const queryClient = useQueryClient()
  const auth = useAuth()

  return useMutation(
    async (project_id: number) => {
      if (!auth.user) throw new Error('User not found')

      // Filter out null and undefined values to allow database defaults to take effect
      const chatbotData = { ...initialChatbot }
      Object.keys(chatbotData).forEach((key) => {
        if (chatbotData[key] === null || chatbotData[key] === undefined) {
          delete chatbotData[key]
        }
      })

      return supabase
        .from('chatbots')
        .insert([
          {
            ...chatbotData,
            owner: auth.user?.id,
            project_id,
          },
        ])
        .select('*')
        .single()
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(['chatbots'])
        queryClient.invalidateQueries(['credits'])
      },
    }
  )
}
